import React from 'react';

import { Stack, Typography, Help } from '@gogame/components';
import { FormField, FormFieldArray, useSiblingFieldName } from '@gogame/form';

import { loadCompensations } from 'scenes/PromoCodes/sources/fields';

import CompensationsPicker from './CompensationsPicker';

const Compensations = ({ name, depends }) => {
  const getName = useSiblingFieldName();

  return (
    <Stack spacing={3}>
      <Stack direction={'row'} spacing={0.5}>
        <Typography fontWeight={'bold'}>Compensation</Typography>
        <Help>
          Compensations will be given to user instead of the main reward if he
          already has this item
        </Help>
      </Stack>
      <CompensationsPicker
        name={name}
        depends={depends}
        source={loadCompensations}
      />
      <FormFieldArray name={getName(name)}>
        {({ value }) => {
          return (
            value?.map((compensation, i) => (
              <FormField.TextField
                key={i}
                name={`${name}[${i}].value`}
                type={'number'}
                placeholder={'0'}
                label={compensation.name}
                {...(compensation.maxValue && {
                  helper: `${compensation.maxValue} maximum`,
                })}
                required={true}
                padding={0}
              />
            )) || null
          );
        }}
      </FormFieldArray>
    </Stack>
  );
};

export default Compensations;
